import { render } from "./NewTicketSecondaryTitle.vue?vue&type=template&id=32ac5fb2"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "32ac5fb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('32ac5fb2', script)) {
    api.reload('32ac5fb2', script)
  }
  
  module.hot.accept("./NewTicketSecondaryTitle.vue?vue&type=template&id=32ac5fb2", () => {
    api.rerender('32ac5fb2', render)
  })

}

script.__file = "src/views/services/pageTitles/NewTicketSecondaryTitle.vue"

export default script